<template>
  <!-- true显示，false不显示 -->
  <div class="handerBox" v-if="distributionIsShow">
    <el-button-group class="comTopRight">
      <el-tooltip class="item" effect="dark" content="点击刷新列表" placement="top-start">
        <el-button size="large" @click="refreshTable">
          <el-icon>
            <RefreshRight />
          </el-icon>
          刷新
        </el-button>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="点击导出当前列表数据(Excel格式)"
        placement="top-start"
      >
        <el-button size="large" @click="downloadExcel">
          <el-icon>
            <Download />
          </el-icon>
          导出
        </el-button>
        {{ columnList }}123
      </el-tooltip>
      <!-- //将所有列展示在此，可以点击进行隐藏与显示 -->
      <el-popover
        popper-class="handerPopoClass"
        placement="bottom"
        width="280"
        trigger="click"
      >
        <div class="trends_btn_wrap">
          <el-checkbox-group v-model="visibleList" :min="1" @change="visibleListChange">
            <el-checkbox
              v-for="(col, i) in columnList"
              :key="i"
              :label="col.label"
              :title="col.value"
              border
              >{{ col.value }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <template #reference>
          <el-button size="large">
            <el-icon>
              <Setting />
            </el-icon>
            设置
          </el-button>
        </template>
      </el-popover>
    </el-button-group>
  </div>
  <!-- 表格 -->
  <div>
    <el-table
      :id="'a' + componentTableId"
      ref="multipleTable"
      :row-key="rowKey"
      :tree-props="treeProps"
      :default-expand-all="defaultExpandAll"
      :cell-style="cellStyle"
      :header-cell-class-name="checkboxAll ? '' : 'disabledCheck'"
      :data="tableData"
      :key="keyRandom"
      tooltip-effect="dark"
      style="width: 100%; margin-top: 10px"
      border
      :empty-text="emptyText"
      :element-loading-text="loadingText"
      :height="tableHeight"
      @select="selectChange"
      @select-all="selectChangeAll"
      @selection-change="selectionChange"
      :default-sort="{ prop: 'date', order: 'descending' }"
      stripe
      v-loading="tableLoading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <template v-for="(headerItem, headerIndex) in headerData">
        <template v-if="!curHideList[headerIndex]">
          <!-- ① 选择器 -->
          <el-table-column
            :label="headerItem.label"
            :prop="headerItem.prop"
            :type="headerItem.type"
            :align="headerItem.align"
            :key="'info8-' + headerIndex"
            :width="headerItem.width"
            :min-width="headerItem.minWidth"
            :fixed="headerItem.fixed"
            :show-overflow-tooltip="!headerItem.noTooltip"
          >
            <template
              #header
              v-if="
                headerItem.type &&
                headerItem.type != '' &&
                headerItem.type !== 'selection'
              "
            >
              <template v-if="headerItem.slotTitle">
                  <slot :name="headerItem.prop + 'Title'"></slot>
              </template>
              <template v-else>
                <el-tooltip
                effect="dark"
                placement="bottom"
                class="item"
                popper-class="mt35"
                :disabled="!headerItem.tipContent"
              >
                <template #content class="content-h">
                  <div v-html="headerItem.titleContent"></div>
                </template>
                <component
                  v-if="
                    Object.prototype.toString.call(headerItem.type) === '[object String]'
                  "
                  :headerItem="headerItem"
                  :headerIndex="headerIndex"
                  :key="headerIndex"
                  :height="50"
                  ref="searchComponent"
                  :is="headerItem.type"
                  @searchFnc="handleSearch"
                ></component>
                <el-popover
                  placement="bottom-start"
                  width="220"
                  trigger="click"
                  :ref="'popover' + headerIndex"
                  v-else
                >
                  <template #reference>
                    <div
                      class="search-header hand"
                      v-if="headerItem.type == 'InputSearch'"
                    >
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;<el-icon style="vertical-align: middle">
                        <Search />
                      </el-icon>
                    </div>
                    <div class="search-header hand" v-else>
                      <span class="search-title">{{ headerItem.label }}</span>
                      &nbsp;<el-icon style="vertical-align: middle">
                        <ArrowDown />
                      </el-icon>
                    </div>
                  </template>
                  <component
                    v-for="(item, index) in headerItem.type"
                    :key="index"
                    ref="searchComponent"
                    :headerItem="item"
                    :headerIndex="index"
                    @searchFnc="handleSearch"
                    :is="item.type"
                    :type="`array`"
                    style="float: left"
                  ></component>
                </el-popover>
              </el-tooltip>
              </template>
             
            </template>
            <!-- 表格行内容 -->
            <template
              #default="{ row, $index }"
              v-if="headerItem.type !== 'selection'"
            >
              <!-- 有单位的普通数据 -->
              <span v-if="headerItem.unit && row[headerItem.prop]"
                >{{ row[headerItem.prop] }}{{ headerItem.unit }}</span
              >
              <!-- 链接跳转 -->
              <span v-if="headerItem.linkJump && row[headerItem.prop]">
                <a
                  class="blue hand"
                  :href="row[headerItem.prop]"
                  target="_blank"
                  v-if="row[headerItem.prop]"
                  >{{ row[headerItem.prop] }}</a
                >
                <span class="gray" v-else>未设置</span>
              </span>
              <!-- 单元格无数据 -->
              <span
                v-if="
                  (isNull(row[headerItem.prop]) && !headerItem.operation) ||
                  row[headerItem.prop] == '未设置'
                "
                class="gray"
                >{{ headerItem.noSetText ? headerItem.noSetText : "未设置" }}</span
              >
              <!-- 图片预览 -->
              <span
                v-else-if="headerItem.isImg && row[headerItem.prop]"
                class="demo-image__preview"
              >
                <el-image
                  style="width: 20px; height: 20px; border: 1px solid #dcdfe6"
                  :src="row[headerItem.prop]"
                  :preview-src-list="[row[headerItem.prop]]"
                  fit="cover"
                  preview-teleported
                  close-on-press-escape
                  hide-on-click-modal
                />
              </span>
              <!-- v-html内容过多 查看详情 -->
              <span
                class="hand blue"
                v-else-if="headerItem.isToMoreContents && row[headerItem.prop]"
                @click="
                  openContent({
                    prop: headerItem.prop,
                    value: row,
                  })
                "
              >
                {{ headerItem.showSelf ? row[headerItem.prop] : "查看详情" }}</span
              >
              <!-- 数组标签 -->
              <span v-else-if="headerItem.isTagArr && row[headerItem.prop]">
                <span v-if="row[headerItem.prop].length > 0">
                  <el-tag v-for="tag in row[headerItem.prop]" :key="tag">{{
                    tag
                  }}</el-tag>
                </span>
              </span>
              <!-- 是(蓝色)否(红色)标签  -->
              <span v-else-if="headerItem.isTag">
                <el-tag
                  :type="row[headerItem.prop] ? '' : 'danger'"
                  size="large"
                  effect="dark"
                >
                  {{ row[headerItem.prop] ? "是" : "否" }}
                </el-tag>
              </span>
              <!-- 自定义插槽 -->
              <slot
                v-else-if="headerItem.custom"
                :name="headerItem.prop + 'Custom'"
                :scope="row"
                :index="$index"
              ></slot>
              <!-- 自定义操作按钮 -->
              <span v-else-if="headerItem.operation">
                <el-button
                  v-if="headerItem.edit"
                  type="primary"
                  size="default"
                  plain
                  @click="handleScope($event, row, 'edit')"
                  >编辑</el-button
                >
                <el-button
                  v-if="headerItem.delete"
                  type="danger"
                  size="default"
                  plain
                  @click="handleScope($event, row, 'delete')"
                  >删除</el-button
                ></span
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ClickOutside as vClickOutside } from "element-plus";
import {
  nextTick,
  reactive,
  toRefs,
  ref,
  unref,
  defineComponent,
  defineExpose,
  toRaw,
  onMounted,
  watch,
} from "vue";
import { useStore } from "vuex";
import InputSearch from "./Components/InputBox.vue";
import SelectSearch from "./Components/DownSelect.vue";
import DateSelect from "./Components/DateSelect.vue";
import CascaderSelect from "./Components/CascaderSelect.vue";
import FileSaver from "file-saver";
// import Selection from "./Components/Selection.vue";
// import OtherData from "./Components/OtherData.vue";
import * as XLSX from "xlsx";
import { lostFocus, formattingDate,timeFormatNew } from "common/utils";
export default defineComponent({
  name: "TableList",
  components: {
    InputSearch,
    SelectSearch,
    DateSelect,
    CascaderSelect,
    // Selection,
    // OtherData,
  },
  props: {
    emptyText: "",
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "loading",
    },
    cellStyle: {
      type: Function,
      default: () => {},
    },
    iscountdown: {
      type: Boolean,
      default: false,
    },
    tableMaxHeight: Number,
    tableHeight: Number,
    headerData: Array,
    tableData: Array,
    tableLoading: {
      type: Boolean,
      default: false,
    },
    pagination: Object,
    height: {
      type: Number,
      default: 400,
    },
    treeProps: {
      //表格树形结构
      type: Object,
      default: {
        children: "children",
      },
    },
    defaultExpandAll: {
      //表格树形结构是否展开
      type: Object,
      default: true,
    },
    rowKey: {
      //表格树形结构key值
      type: String,
      default: "id",
    },
    //导出的Excel名称
    excelName: "",
    //需要导出的表格Table ID
    componentTableId: "",
    redColor: {
      //列表数据
      type: Boolean,
      default: false,
    },
    tableList: {
      //列表数据
      type: Array,
      require: true,
      default: () => [],
    },
    hideColumnIndexs: {
      //需要隐藏的列的下标即表格数据的序号从0开始
      type: Array,
      default: () => [],
    },
    distributionIsShow: {
      type: Boolean,
      default: true,
    },
    // 控制表格全选显隐
    // 默认true 显示  false 隐藏
    checkboxAll: {
      type: Boolean,
      default: true,
    },
  },
  // 定义属性
  setup(props, { emit }) {
    // debugger;
    // 声明数据并使用proxy监听
    const data = reactive({
      scope: [],
      dateTime: null,
      checked: false,
      conKey: false, //避免el-table 表体数据发生变化时，未重新渲染问题
      handleSelection: [],
      isAll: false, //全选参数
      visibleList: [], //显示/隐藏列的选中下标数据集合
      columnList: [], //表格所有列名称数据列表
      curHideList: [],
      keyRandom: null,
      ids: [], //存放已选数据
      IdName: "",
    });
    // 去掉proxy监听数据，使数据恢复正常
    var headerData = JSON.parse(JSON.stringify(props.headerData));
    var tableData = JSON.parse(JSON.stringify(props.tableData));
    // 获取ref
    const multipleTable = ref(null);
    const popoverRef = ref();
    // 通过id获取对应的name
    const textIds = (row, selectOptions, headerItem) => {
      // console.log(selectOptions, "--------------123");
      // console.log(row, "--------------123");
      // 判断是级联选择框还是下拉选择框
      if (selectOptions && selectOptions.length > 0) {
        // console.log(catrgoryOptions(selectOptions, row, headerItem), 321123);
        return catrgoryOptions(selectOptions, row, headerItem);
      }
    };
    // 级联数据匹配label值
    const catrgoryOptions = (options, value, headerItem, isdata) => {
      // var length = options.length || 0;
      // console.log(headerItem, 11233);
      var data = [];
      options.map((item) => {
        // console.log(item, "------------------匹配的值");
        if (item[headerItem.cascaderValuePost || headerItem.prop] == value) {
          data = item;
          // console.log(data, "------结果1");
        }
        if (
          item[headerItem.cascaderChildren || "children"] &&
          item[headerItem.cascaderChildren || "children"].length > 0
        ) {
          item[headerItem.cascaderChildren || "children"].map((item1) => {
            // console.log(item1[headerItem.cascaderValuePost], "-----遍历的值");
            // console.log(item1[headerItem.cascaderValuePost] == value, "-----判断");
            if (item1[headerItem.cascaderValuePost || headerItem.prop] == value) {
              data = item1;
              // console.log(data, "------结果2");
            }
          });
        }
      });
      if (data.length != 0) {
        return data[headerItem.cascaderLabel || "label"];
      } else {
        return "未设置";
      }
    };
    // 点击内容
    const clickText = (val, prop) => {
      emit("handleCard", val, prop);
    };
    const refData = toRefs(data);
    // 监听
    watch(
      () => props.tableData,
      (newValue) => {
        nextTick(() => {
          handleSelectionIn();
        });
      },
      {
        deep: true,
        // immediate: true,
      }
    );
    // 点击表格内操作模块
    const handleScope = (e, val, statu) => {
      // 强制移除按钮焦点
      lostFocus(e);
      if (statu == "edit") {
        emit("handleEdit", val);
      }
      if (statu == "delete") {
        emit("handleDelete", val);
      }
      if (statu == "view") {
        emit("handleView", val);
      }
      
    };
    // 组件渲染钩子函数
    onMounted(() => {
      headerData.map((obj, index) => {
        // console.log(obj.type);
        // console.log(obj.label);

        if (obj.label) {
          data.columnList.push({
            label: index,
            value: obj.type == "selection" ? "选择" : obj.label,
          });

          // 记录初始展示的列
          if (props.hideColumnIndexs.indexOf(index) === -1) {
            data.visibleList.push(index);
            data.curHideList[index] = false;
          } else {
            data.curHideList.push(true);
          }
        }
        if (obj.type == "selection") {
          console.log(obj.IdName, "初始化IdName");
          data.IdName = obj.IdName;
          handleSelectionIn();
        }
      });
      // handleSelectionIn();
    });
    //刷新表格
    const refreshTable = () => {
      
      //直接执行父组件中的更新列表方法
      emit("update-list");
    };
    //导出Excel
    const downloadExcel = () => {
      if (props.componentTableId == "") ElMessage("参数表格ID不能为空,请检查!");
      let talbleId = "#a" + props.componentTableId;
      // table要导出的是哪一个表格
      let table = document.querySelector(talbleId).cloneNode(true);
      var dropdownObj = document.querySelectorAll(
        ".el-select-dropdown,.el-cascader__dropdown"
      );
      //表头是否有下拉框
      dropdownObj.forEach((element) => {
        element.parentNode.removeChild(element);
      });
      // //删掉table表头的下拉框，不然导出的Excel的表头会把下拉框里所有的值带上
      // dropdownObj.parentNode.removeChild(dropdownObj);
      // 因为element-ui的表格的fixed属性导致多出一个table，会下载重复内容，这里删除掉
      var fixedObj = table.querySelector(".el-table__fixed");
      if (fixedObj) {
        var fa = fixedObj.parentNode;
        fa.removeChild(fixedObj);
      }
      let wb = XLSX.utils.table_to_book(table, { raw: true }); //获取表格数据
      let etout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([etout], {
            type: "application/octet-stream",
          }),
          props.excelName + ".xlsx"
        ); //this.excelName.xlsx 为导出的文件名
      } catch (e) {}
      return etout;
    };
    // 设置
    const visibleListChange = (item) => {
      var _this = this;
      // var curHideList = [];
      data.columnList.forEach((obj, index) => {
        data.curHideList[index] = false;
        // 更改显示隐藏列
        if (item.indexOf(index) === -1) {
          data.curHideList[index] = true;
        }
      });
      emit("update-list");
      data.keyRandom = Math.random();
      // emit("getHideColist", curHideList);
    };
    // 搜索组件
    const handleSearch = (val) => {
      console.log(val, "32123");
      emit("searchFnc", val);
    };
    // 初始化表单
    const handleSelectionIn = () => {
      props.headerData.map((item) => {
        if (item.type === "selection") {
          if (item.ids && item.ids.length > 0) {
            // 默认选中渲染勾选
            props.tableData.map((item1, index) => {
              if (item.ids.indexOf(item1[item.IdName || "id"]) != -1) {
                nextTick(() => {
                  multipleTable.value.toggleRowSelection(item1, true);
                });
                // data.handleSelection.push(item1);
                // data.handleSelection = addArrayList(data.handleSelection, [item1]);
              }
            });
            data.ids = item.ids;
            data.IdName = item.IdName;
          }
         
        }
      });
    };

    // 全选
    const selectChangeAll = (rows) => {
      var handleSelection = [];
      props.headerData.map((item) => {
        if (item.type === "selection" && item.ids && item.ids.length > 0) {
          data.ids = item.ids;
        }
      });
      console.log(data.ids, props.headerData, rows, props.tableData, "全选");
      // 已选中的数据添加到判断中来。
      // if (data.ids && data.ids.length > 0) {
      handleSelection = addArrayList(data.ids, rows);
      // }

      headerData.map((item) => {
        if (item.type === "selection") {
          if (item && item.limit && item.limit.length > 0 && item.limit[0] != 0) {
            if (handleSelection && handleSelection.length > item.limit[0]) {
              // 全选
              ElMessage.warning(`最多只能选择${item.limit[0]}个${item.limit[1]}`);
              rows.map((row) => {
                nextTick(() => {
                  multipleTable.value.toggleRowSelection(row, false);
                });
              });
              handleSelectionIn();
              handleSelection = data.ids;
            }
            if (rows && rows.length == 0) {
              // 取消
              data.ids = [];
              props.tableData.map((item) => {
                handleSelection = deleteArrayList(handleSelection, item);
              });
            }
          } else {
            // 取消全选
            if (rows && rows.length == 0) {
              // 取消
              data.ids = [];
              props.tableData.map((item) => {
                handleSelection = deleteArrayList(handleSelection, item);
              });
            }
          }
        }
      });
      console.log(handleSelection, "全选传递的数据");
      emit("select-all", handleSelection, rows);
    };
    // 单选、多选
    const selectChange = async (rows, row) => {
      // var rowList = JSON.parse(JSON.stringify(rows));
      var handleSelection = [];
      props.headerData.map((item) => {
        if (item.type === "selection" && item.ids && item.ids.length > 0) {
          data.ids = item.ids;
        } else {
          data.ids = [];
        }
      });
      // 已选中的数据添加到判断中来。
      // if (data.ids && data.ids.length > 0) {
      handleSelection = addArrayList(data.ids, rows);
      // }
      console.log(handleSelection, data.ids);
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (selected) {
        // 选中
        headerData.map((item) => {
          if (item.type === "selection") {
            if (item && item.limit && item.limit.length > 0 && item.limit[0] == "free") {
              nextTick(() => {
                multipleTable.value.toggleRowSelection(row, true);
              });
              handleSelection = rows;
            }
            if (item && item.limit && item.limit.length > 0 && item.limit[0] > 1) {
              // 选中控制参数大于1的情况，判断默认选中数据加上点选的数据是否大于最大数据
              if (handleSelection && handleSelection.length > item.limit[0]) {
                // 大于，取消选中状态 提示
                ElMessage.warning(`最多只能选择${item.limit[0]}个${item.limit[1]}`);
                nextTick(() => {
                  multipleTable.value.toggleRowSelection(row, false);
                });
                // 删除指定数据
                handleSelection = deleteArrayList(handleSelection, row);
              }
              // 选中数少于最大数的情况,不做处理.在上面步骤中已经把当前选中的数据加入到返回数组中去了.
            }
            if (item && item.limit && item.limit.length > 0 && item.limit[0] == 1) {
              // 单选 去掉之前选中的数据渲染
              if (rows.length > 1) {
                nextTick(() => {
                  multipleTable.value.toggleRowSelection(rows[0], false);
                });
                // 选中数据处理, 只显示当前选中的数据
              }
              handleSelection = [row.id];
            }
          }
        });
      } else {
        // 取消
        handleSelection = deleteArrayList(handleSelection, row);
      }

      console.log(handleSelection);
      emit("selectChange", handleSelection, row, rows);
    };
    // 数组添加不重复的数据
    const addArrayList = (valArrs, newValArrs) => {
      var valArrNew = JSON.parse(JSON.stringify(valArrs));
      newValArrs.map((item) => {
        // if(item.id)
        var addArr = valArrNew.filter((o) => o == item[data.IdName || "id"]);
        if (addArr && addArr.length == 0) {
          valArrNew.push(item[data.IdName || "id"]);
        }
      });
      return valArrNew;
    };
    // 删除指定数据
    const deleteArrayList = (valArrs, newValArr) => {
      return valArrs.filter((o) => o != newValArr[data.IdName || "id"]);
    };
    const onClickOutside = () => {
      unref(popoverRef).popperRef?.delayHide?.();
    };
    const selectionChange = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
      emit("handle-selection", data.multipleSelection);
    };
    const cancerSelectRow = (row) => {
      multipleTable.value.toggleRowSelection(row, false);
    };
    //  去掉全选按钮
    const disabledCheck = (row) => {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    };
    // 判断是否是有效数据
    const isNull = (obj) => {
      if (
        obj === "" ||
        obj === 0 ||
        obj === undefined ||
        obj === null ||
        obj === "undefined" ||
        obj === "null" ||
        obj.length === 0 ||
        obj === "00000000-0000-0000-0000-000000000000"
      ) {
        return true;
      }
      return false;
    };
    //查看详情
    const openContent = (val) => {
      emit("open-content", val);
    };
    return {
      ...refData,
      handleSearch,
      textIds,
      clickText,
      selectChange,
      selectChangeAll,
      selectionChange,
      cancerSelectRow,
      multipleTable,
      handleSelectionIn,
      refreshTable,
      downloadExcel,
      visibleListChange,
      handleScope,
      onClickOutside,
      isNull,
      openContent
    };
  },
});
</script>

<style scoped>
.comTopRight {
  position: absolute;
  top: 8px;
  right: 5px;
  display: inline-block;
  margin-right: 10px;
}

*/deep/ .noData.el-tag {
  border: 1px solid rgba(192, 192, 192, 0.6);
  background-color: rgba(192, 192, 192, 0.1);
  color: #9e9ea2;
}

.trends_btn_wrap {
  width: 300px;
}

.trends_btn_wrap >>> .el-checkbox {
  width: 45%;
  margin-bottom: 20px;
  margin-right: 15px;
}

.trends_btn_wrap >>> .el-checkbox__label {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .el-input__suffix {
  display: table-cell;
  vertical-align: bottom;
  margin-right: 0px !important;
}

>>> .el-input__inner {
  width: 90%;
}

>>> .el-input__icon {
  vertical-align: middle;
  margin-top: 12px;
  box-sizing: border-box;
}

>>> .el-input__wrapper {
  /* height: 40px; */
  width: 100%;
}
/* 深度选择器 去掉全选按钮 */
::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
  display: none;
}

::v-deep .el-table .disabledCheck .cell::before {
  content: "";
  text-align: center;
}
</style>
